export default {
	common: {
		username: '用户名',
		password: '密码',
		save: '保存',
		edit: '编辑',
		update: '更新',
		delete: '删除',
		forever: '永久',
		expired: '过期'
	},
	"login.login.443414-0": "登录",
	"login.login.443414-1": "请输入用户名",
	"login.login.443414-2": "请输入密码",
	"login.login.443414-3": "记住密码",
	"login.login.443414-4": "修改密码",
	"login.login.443414-5": "账号",
	"login.login.443414-6": "请输入",
	"login.login.443414-7": "原密码",
	"login.login.443414-8": "新密码",
	"login.login.443414-9": "确认密码",
	"login.login.443414-10": "取消",
	"login.login.443414-11": "确认",
	"login.login.443414-12": "扫码下载App",
	"login.login.443414-13": "Android 扫码下载",
	"login.login.443414-14": "IOS 微信扫码访问",
	"login.login.443414-15": "中国燃气、电气智能安全监测控制平台",
	"login.login.443414-16": "信尔德燃气、电气智能安全监测控制平台",
	"login.login.443414-17": "用电安全管理平台",
	"login.login.443414-18": "账号已在别处登录",
	"login.login.443414-19": "请先填写必填项!",
	"login.login.443414-20": "用户名不能为空",
	"login.login.443414-21": "密码不能为空"
}


// WEBPACK FOOTER //
// ./src/i18n/lang/Zh/login-zh.js